export const LINK_TO_LOGOUT = "/auth/logout"; //link to logout page
export const LINK_TO_REFRESH_TOKEN_API = '/admin-sessions' // link to refresh auth token;